/**
 * Ist gerade ein Dialog oder Aufklappmenü offen? Dann gehört Escape diesem –
 * Panels und Bereiche sollen sich dabei nicht mitschließen.
 */
export function ueberlagerungOffen(): boolean {
  return typeof document !== 'undefined'
    && document.querySelector([
      '[role="alertdialog"]', '[role="dialog"]', '[role="menu"]', '[role="listbox"]',
      // bestehende Formulare ohne Dialog-Rolle, beim Einbinden markiert
      '[data-immo-ueberlagerung]', '[data-zaehler-modal]',
      // offenes Formular in der Island (z. B. „Termin anlegen“)
      '[data-island] input', '[data-island] textarea', '[data-island] select',
    ].join(', ')) !== null;
}
